import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/auth/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';

/**
 * Objeto de configuración global para el arranque (bootstrap) de la aplicación Angular.
 *
 * Centraliza la inyección de dependencias a nivel de aplicación, estableciendo los cimientos
 * de la navegación, la comunicación HTTP segura, el motor de animaciones y la identidad visual
 * del sistema. Al usar el patrón de "Standalone", este objeto sustituye la configuración
 * tradicional basada en NgModules.
 */
export const appConfig: ApplicationConfig = {
  /**
   * Colección de proveedores de servicios globales.
   * * - `provideRouter`: Establece la estrategia de navegación y carga de componentes.
   * - `provideHttpClient`: Configura el cliente de red con un pipeline de interceptores.
   * - `authInterceptor`: Inyecta automáticamente los tokens de seguridad en las cabeceras.
   * - `errorInterceptor`: Captura y normaliza las excepciones de red antes de que lleguen al componente.
   * - `provideAnimations`: Habilita el soporte para el motor de animaciones (necesario para las transiciones de ruta).
   * - `providePrimeNG`: Inicializa la librería de componentes UI con el tema 'Lara' y soporte para modo oscuro.
   */
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: '.app-dark',
        },
      },
    }),
  ],
};
